import { qs, qsa, add, remove } from "@fluorescent/dom";
import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  partial: "[data-partial]",
  filterTopBar: ".animation--filter-topbar",
  filterSidebar: ".animation--filter-sidebar",
  resultItems: ".animation--item:not(.animation--item-revealed)",
};

const classes = {
  hideProducts: "animation--container-hide",
  itemRevealed: "animation--item-revealed",
};

export default node => {
  const partial = qs(selectors.partial, node);
  const filterTopBarEl = qs(selectors.filterTopBar, node);
  const filterSidebarEl = qs(selectors.filterSidebar, node);

  let filterTopBarObserver = null;
  let filterSidebarObserver = null;

  if (filterTopBarEl) {
    filterTopBarObserver = intersectionWatcher(filterTopBarEl, true);
  }

  if (filterSidebarEl) {
    filterSidebarObserver = intersectionWatcher(filterSidebarEl, true);
  }

  setupProductItem();

  function setupProductItem() {
    let resultItems = qsa(selectors.resultItems, node);

    delayOffset(node, [selectors.resultItems]);
    setTimeout(() => {
      add(resultItems, classes.itemRevealed);
    }, 0);
  }

  function updateContents() {
    setupProductItem();
    remove(partial, classes.hideProducts); // Remove the fade out class
  }

  function infiniteScrollReveal() {
    setupProductItem();
  }

  return {
    updateContents,
    infiniteScrollReveal,
    destroy() {
      filterTopBarObserver?.destroy();
      filterSidebarObserver?.destroy();
    },
  };
};
